import { Injectable } from "@angular/core";
import { Http, Response, URLSearchParams, Headers, RequestOptions } from "@angular/http";
import { Observable } from "rxjs/Observable";
import { AdalHttp } from '../../services/adal.http.service';
import "rxjs/add/operator/map";
import "rxjs/add/operator/do";
import "rxjs/add/operator/catch";

@Injectable()
export class DeviceCACertificateManagementService {

    apiEndPoint: string = window.location.protocol + "//" + window.location.host + "/api/devicecacertificate";

    constructor(private http: AdalHttp) {
    }

    addSystemType(systemType: string, ownershipCodeGenerationType: string): Observable<any> {
        var headers = new Headers();
        headers.append('Content-Type', 'application/json');
        var requestBody = {
            'SystemType': systemType,
            'OwnershipCodeGenerationType': ownershipCodeGenerationType
        };
        let productUrl: string = window.location.protocol + "//" + window.location.host + "/api/devicecacertificate";
        return this.http.post(productUrl, JSON.stringify(requestBody), {
            headers: headers
        })
            .catch((error: any) => {
                return Observable.throw(error);
            });
    }

    retrieveCACertificates(): Observable<any> {
        var headers = new Headers();
        headers.append('Content-Type', 'application/json');
        let productUrl: string = window.location.protocol + "//" + window.location.host + "/api/devicecacertificate";
        return this.http.get(productUrl)
            .catch((error: any) => {
                return Observable.throw(error || 'server error');
            });
    }

    validateCertificate(formData: FormData): Observable<any> {
            let headers = new Headers();
            return this.http.post(`${this.apiEndPoint}/preview`, formData)
                .catch(error => Observable.throw(error || 'server error'));
    }

    uploadCertificate(formData: FormData): Observable<any> {
        return this.http.post(`${this.apiEndPoint}`, formData)
            .catch(error => Observable.throw(error || 'server error'));
    }
}


/** WEBPACK FOOTER **
 ** ./F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/app/main/DeviceCACertificateManagement/manage-device-ca-certificates-service.ts
 **/